import React from 'react';
import { observable, decorate } from "mobx";
import CardContent from '@material-ui/core/CardContent';
import { I18n } from 'aws-amplify';
import ActionModel from "../../../../../models/ActionModel/ActionModel";
import UserName from '../../NewAction/inputs/UsernameInput/UsernameInput'
import NewActionHeader from '../../NewAction/NewActionHeader/NewActionHeader';

class LinkedinAction extends ActionModel {

	static metadata = {
		id: "linkedin",
		name: "Linkedin",
		icon: "https://l.fast.cm/content/icons/linkedin.png",
		categories: {
			// social: true
		}
	};

	constructor(dat) {
		super();
		// this.propNames = ["Title", "Image", "Subtitle", "ButtonText", "destId"];
		this.propNames.push("destId");
		this.setFromObject(dat);
	}

	Title = "Linkedin";
	Link = "https://www.Linkedin.com/in/"
	ButtonText = "GO";
	isValid = false
	destId = "";


	onValidateUrl = () => {
		this.isValid = true
	}

	getConfigCardBody(cardModel, handleOnChangeIcon) {
		return (
			<CardContent>
				<NewActionHeader
					onChangeIcon={handleOnChangeIcon}
					actionModel={this} />
				<UserName
					placeHolderText={I18n.get("_username")}
					cardModel={cardModel}
					actionModel={this} />
			</CardContent >
		)
	}

	getRules() {
		return {
			destId: {
				presence: { allowEmpty: false }
			},
			...super.getRules()
		}
	}
}

decorate(LinkedinAction, {
	Title: observable,
	Link: observable,
	ButtonText: observable,
	isValid: observable,
	destId: observable
})

export default LinkedinAction
